/**
 * background-store.js
 * バッチなどのバックグラウンド処理に関連するデータストア
 */

// バックグランド関連APIリクエスト用I/F
import backgroundInterface from '@/api/background/background-interface'
// バックグランド関連API
import backgroundApi from '@/api/background/background-api'

export default {
  namespaced: true,
  state: {
    // バッチタスク一時停止フラグ
    // ※キー名はDBのフィールド名を使う
    taskSuspendFlag: {
      // 媒体連携
      media_cooperation: false,
      // 自動採用フロー
      auto_recruitment_flow_action: false,
    }
  },
  actions: {
    /**
     * バッチタスク一時停止フラグ取得
     * @param {Object} param0 ストアオブジェクト
     * @param {String} modalName モーダル名
     */
    getBatchTaskSuspendFlag ({commit}) {
      try {
        const backgroundIf = new backgroundInterface()
        const queryParameter = backgroundIf.makeBatchTaskSuspendFlagGetParameter()
        backgroundApi.getBatchTaskRequest(queryParameter)
          .then((response) => {
            // 取得したバッチタスク一時停止フラグをストアに設定
            commit('setBatchTaskSuspendFlag', response.data)
          })
          .catch(error => {
            throw error
          })
      } catch (error) {
        throw error
      }
    },
    /**
     * バッチタスク一時停止
     * @param {Object} param0 ストアオブジェクト
     * @param {Object} payload ペイロード
     */
    async batchTaskSuspend ({commit}, componentTag) {
      try {
        const backgroundIf = new backgroundInterface()
        // 媒体連携項目マスター設定で一時停止するタスクのリストを取得
        const taskList = backgroundIf.getTaskList(componentTag)
        const Payload = backgroundIf.makeBatchTaskSuspendPayload(taskList)
        return await backgroundApi.patchBatchTaskRequest(Payload)
          .then((response) => {
            // 取得したバッチタスク一時停止フラグをストアに設定
            commit('setBatchTaskSuspendFlag', response.data)
          })
          .catch(error => {
            throw error
          })
      } catch (error) {
        throw error
      }
    },
    /**
     * バッチタスク再開
     * @param {Object} param0 ストアオブジェクト
     * @param {Object} payload ペイロード
     */
    batchTaskResume ({commit}, componentTag) {
      try {
        const backgroundIf = new backgroundInterface()
        // 媒体連携項目マスター設定で一時停止するタスクのリストを取得
        const taskList = backgroundIf.getTaskList(componentTag)
        const Payload = backgroundIf.makeBatchTaskResumePayload(taskList)
        backgroundApi.patchBatchTaskRequest(Payload)
          .then((response) => {
            // 取得したバッチタスク一時停止フラグをストアに設定
            commit('setBatchTaskSuspendFlag', response.data)
          })
          .catch(error => {
            throw error
          })
      } catch (error) {
        throw error
      }
    },
  },
  mutations: {
    /**
     * バッチタスク一時停止フラグセット
     * @param {Object} state ステート
     * @param {Object} taskSuspendFlagList バッチタスク一時停止フラグ
     */
    setBatchTaskSuspendFlag (state, taskSuspendFlagList) {
      for (let suspendFlag of taskSuspendFlagList) {
        state.taskSuspendFlag[suspendFlag.task_name] = Boolean(suspendFlag.task_status)
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/background/background-store.js